import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import request from 'src/utils/request'
import { toast } from 'react-toastify'
import { jwtDecode } from 'jwt-decode'

export const getStudentByID = createAsyncThunk(
  'auth/getStudentByID',
  async ({ MATRICULE }, thunkAPI) => {
    try {
      
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/student`, {
        params: { MATRICULE },
      })
      const data = await res.data      
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const changeStudentPassword = createAsyncThunk(
  'auth/changeStudentPassword',
  async ({ MATRICULE, password, newPassword, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/change-password`, {
        MATRICULE,
        password,
        newPassword,
      })
      const message =
        lang === 'Français'
          ? 'Votre mot de passe a été modifié avec succès'
          : 'Your password updated successfully'
      toast.success(message)
      const data = await res1.data

      return data
    } catch (err) {
      if (err.response.status === 400) {
        toast.error(
          lang === 'Français'
            ? `Erreur ! Votre ancien mot de passe est incorrect`
            : `Error ! Your old password is incorrect`,
        )
      } else {
        toast.error(
          lang === 'Français'
            ? `Erreur ! Votre mot de passe n'a pa pu être modifié`
            : `Error ! Your password could not be changed`,
        )
      }
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const signReglement = createAsyncThunk(
  'auth/signReglement',
  async ({ MATRICULE, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/sign-reglement`, {
        MATRICULE,
      })
      const message =
        lang === 'Français'
          ? 'Le règlement intérieur a été signé avec succès.'
          : 'The rules of procedure have been successfully signed.'
      toast.success(message)
      const data = await res1.data

      return data
    } catch (err) {
      toast.error(
        lang === 'Français'
          ? `Erreur dans la signature du règlement intérieur. Veuillez réessayer plus tard.`
          : `Error in the signature of the rules of Procedure. Please try again later.`,
      )

      return thunkAPI.rejectWithValue(message)
    }
  },
)

/*export const checkStudent = createAsyncThunk(
  'auth/checkStudent',
  async ({ MATRICULE }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/auth`, {
        params: { MATRICULE },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)*/

export const changeLanguage = createAsyncThunk(
  'auth/changeLanguage',
  async ({ MATRICULE, language, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/changeLanguage`, {
        MATRICULE,
        language,
      })
      const res = await request(token).get(`/students/auth`, {
        params: { MATRICULE },
      })
      const data = await res.data

      localStorage.setItem('studentInfo', JSON.stringify(data))
      lang === 'Français'
        ? toast.success('Profil modifié avec succès')
        : toast.success('Profile updated successfully')
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const updateStudent = createAsyncThunk(
  'auth/updateStudent',
  async ({ formData, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/student`, formData, {
        headers: {
          'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      const message =
        lang === 'Français'
          ? 'Votre profil a été modifié avec succès'
          : 'Your profile updated successfully'
      toast.success(message)
      const data = await res1.data
      return data
    } catch (err) {
      //      console.log(err)
      const message =
        lang === 'Français'
          ? `Erreur Votre profil n'a pa pu être modifié`
          : `Error ! Your profile could not be modified`
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const updateProfileStudent = createAsyncThunk(
  'auth/updateProfileStudent',
  async ({ viewProfile, MATRICULE, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/viewProfile`, viewProfile)
      const res = await request(token).get(`/students/auth`, {
        params: { MATRICULE },
      })
      const data = await res.data
      lang === 'Français'
        ? toast.success('Profil modifié avec succès')
        : toast.success('Profile updated successfully')
      localStorage.setItem('studentInfo', JSON.stringify(data))
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

function vertifyToken() {
  try {
    if (!localStorage.getItem('studentInfo')) {
      return null
    } else {
      const token = JSON.parse(localStorage.getItem('studentInfo')).token
      if (jwtDecode(token).exp * 1000 < Date.now()) {
        localStorage.removeItem('studentInfo')
        return null
      } else {
        return JSON.parse(localStorage.getItem('studentInfo'))
      }
    }
  } catch (error) {
    //console.log(error)
    localStorage.removeItem('studentInfo')
    return null
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    student: vertifyToken(),
    //user: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
    currentStudentData: [],
    registerMessage: null,
    isLoading: false,
    isSuccess: false,
    error: false,
  },
  reducers: {
    login(state, action) {
      state.student = action.payload
      state.registerMessage = null
    },
    logout(state) {
      state.student = null
      state.currentStudentData = []
    },
    register(state, action) {
      state.registerMessage = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStudentByID.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getStudentByID.fulfilled, (state, action) => {
        return {
          ...state,
          currentStudentData: action.payload,
          isLoading: false,
        }
      })
      .addCase(getStudentByID.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
        }
      })
      .addCase(changeStudentPassword.fulfilled, (state, action) => {
        localStorage.removeItem('studentInfo')
        return {
          ...state,
        }
      })
      .addCase(updateProfileStudent.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(updateProfileStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          student: action.payload,
          error: '',
        }
      })
      .addCase(updateProfileStudent.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(changeLanguage.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(changeLanguage.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          student: vertifyToken(),
          error: '',
        }
      })
      .addCase(changeLanguage.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

const authReducer = authSlice.reducer
const authActions = authSlice.actions

export { authActions, authReducer }
